<template>
  <div class="flex items-center">
    <div class="w-full max-w-lg">
      <form @submit.prevent="submit">
        <div class="pb-8">
          <text-input @input="setFirstName" :value="$page.auth.user.first_name" :required="true" :errors="$page.errors.first_name" class="mt-4" label="Prenume" type="text" autofocus autocapitalize="on" />
          <text-input @input="setLastName" :value="$page.auth.user.last_name" :required="true" :errors="$page.errors.last_name" class="mt-4" label="Nume" type="text" autocapitalize="on" />
          <text-input :value="$page.auth.user.email" :disabled="true" class="mt-4" label="Email" type="email" />
          <select-input @input="setGender" v-model="$page.auth.user.gender" :errors="$page.errors.gender" class="mt-4" label="Sex">
            <option value="1" >Bărbat</option><option value="2" >Femeie</option>
          </select-input>
          <div class="flex flex-col mt-4 w-full">
            <label class="form-label">Data nașterii</label>
            <div class="flex flex-row mt-1 w-full">
              <select-input class="w-1/3" @input="setDateOfBirthDay" :value="dateOfBirthDay" :errors="$page.errors.date_of_birth_day">
                <option v-for="day in 31" :key="day" :value="day">{{ day }}</option>
              </select-input>
              <select-input class="w-1/3" @input="setDateOfBirthMonth" :value="dateOfBirthMonth" :errors="$page.errors.date_of_birth_month">
                <option v-for="month in 12" :key="month" :value="month">{{ month }}</option>
              </select-input>
              <select-input class="w-1/3" @input="setDateOfBirthYear" :value="dateOfBirthYear" :errors="$page.errors.date_of_birth_year">
                <option v-for="year in 120" :key="year" :value="120 - year + 1900">{{ 120 - year + 1900 }}</option>
              </select-input>
            </div>
          </div>
        </div>
        <div class="py-4 bg-grey-100 border-grey-200 flex justify-start items-center">
          <loading-button :loading="sending" class="btn-gray" type="submit">Salvează</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import AccountLayout from '@/Shared/Account/Layout'
import LoadingButton from '@/Shared/LoadingButton'
import SelectInput from '@/Shared/SelectInput'
import TextInput from '@/Shared/TextInput'

export default {
  metaInfo() {
    return {
      title: 'Contul meu',
      meta: [ 
        { name: 'robots', content: 'noindex, nofollow, nosnippet, noarchive' },
        { name: 'googlebot', content: 'noindex, nofollow, nosnippet, noarchive' }
      ]
    }
  },
  layout: (h, page) => {
    return h(Layout, [
      h(AccountLayout, [page]),
    ])
  },
  components: {
    LoadingButton,
    TextInput,
    SelectInput,
    AccountLayout,
    Layout
  },
  props: {
    errors: Object,
  },
  data() {
    return {
      sending: false,
      form: {
        firstName: null,
        lastName: null,
        gender: null,
        dateOfBirthDay: null,
        dateOfBirthMonth: null,
        dateOfBirthYear: null
      },
    }
  },
  computed: {
    dateOfBirthDay() {
      return new Date(this.$page.auth.user.date_of_birth).getDate() + 1
    },
    dateOfBirthMonth() {
      return new Date(this.$page.auth.user.date_of_birth).getMonth() + 1
    },
    dateOfBirthYear() {
      return new Date(this.$page.auth.user.date_of_birth).getFullYear()
    }
  },
  methods: {
    submit() {
      this.sending = true
      this.$inertia.put(this.route('shop.account.update'), {
        first_name: this.form.firstName ? this.form.firstName : this.$page.auth.user.first_name,
        last_name: this.form.lastName ? this.form.lastName : this.$page.auth.user.last_name,
        gender: this.form.gender ? this.form.gender : this.$page.auth.user.gender,
        date_of_birth_day: this.form.dateOfBirthDay ? this.form.dateOfBirthDay : this.dateOfBirthDay,
        date_of_birth_month: this.form.dateOfBirthMonth ? this.form.dateOfBirthMonth : this.dateOfBirthMonth,
        date_of_birth_year: this.form.dateOfBirthYear ? this.form.dateOfBirthYear : this.dateOfBirthYear
      }).then(() => this.sending = false)
    },
    setFirstName(firstName) {
      this.form.firstName = firstName
    },
    setLastName(lastName) {
      this.form.lastName = lastName
    },
    setGender(gender) {
      this.form.gender = gender
    },
    setDateOfBirthDay(dateOfBirthDay) {
      this.form.dateOfBirthDay = dateOfBirthDay
    },
    setDateOfBirthMonth(dateOfBirthMonth) {
      this.form.dateOfBirthMonth = dateOfBirthMonth
    },
    setDateOfBirthYear(dateOfBirthYear) {
      this.form.dateOfBirthYear = dateOfBirthYear
    }
  }
}
</script>
